




































import Vue from 'vue';
import VueSlider from 'vue-slider-component';

export default Vue.extend({
  name: 'HeatmapSlider',
  components: { VueSlider },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
      type: Array,
    },
    flip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    direction() {
      return this.flip ? 'rtl' : 'ltr';
    },
    sliderRanges() {
      if (this.disabled) {
        return [];
      }

      const ranges = [0];
      this.value.forEach(range => {
        if (range.max > 0) {
          ranges.push(range.max);
        }
      });
      return ranges.sort((a, b) => a - b);
    },
    dotOptions() {
      if (this.value.length <= 2) {
        return [];
      }

      const options = <Object[]>[
        {
          disabled: true,
          style: {
            display: 'none',
          },
        },
      ];

      for (let i = 0; i < this.value.length - 2; i++) {
        options.push({
          style: {
            backgroundColor: this.value[i + 1].color,
          },
        });
      }

      options.push({
        disabled: true,
        style: {
          backgroundColor: this.value[this.value.length - 1].color,
        },
      });
      return options;
    },
  },
  methods: {
    processHandler(dotsPos: Array<number>) {
      const processes = [];
      for (let i = 1; i < dotsPos.length; i++) {
        processes.push([dotsPos[i - 1], dotsPos[i], { backgroundColor: this.value[i].color }]);
      }
      return processes;
    },
    changeHandler(val) {
      const thresholds = [...this.value];
      for (let i = 1; i < thresholds.length; i++) {
        thresholds[i].max = val[i];
        thresholds[i].min = val[i - 1];
      }
      this.$emit('input', thresholds);
    },
    thresholdTitleColor(index: number) {
      return (this.value[index + 1] || {}).color;
    },
    thresholdTitle(index: number) {
      return (this.value[index + 1] || {}).title || '';
    },
    onDragEnd() {
      this.$emit('modifiedThreshold');
    },
  },
});
